import React from 'react';
import { Field as FormField } from 'react-final-form';

import {
	FIELD_DESCRIPTION,
	FIELD_TEXT,
	FIELD_TEXTAREA,
	FIELD_TITLE,
	FIELDS_INPUT_DECISION_RADIOGROUP,
	FIELDS_START_END_INPUTS
} from 'constants/fields';

import { Editor } from 'UI/Inputs';
import { Icon } from '@haldor/ui';

import './Field.scss';
import DecisionRadioGroup from 'UI/Inputs/DecisionRadioGroup';
import StartEndInputs from 'UI/Inputs/StartEndInputs';

const Field = (props) => {
	const { type } = props;

	const renderTitle = () => (
		<div onClick={props.onLabelClick} className="input-label">
			{props.onLabelClick != null ? <Icon name="Chevron" /> : null}
			{props.value}
		</div>
	);

	const renderDescription = () => <div>{props.value}</div>;

	const renderText = () => (
		<div className="input-field">
			<FormField
				name={props.name}
				render={({ input, meta }) => (
					<input
						{...input}
						type="text"
						placeholder={props.placeholder}
						disabled={props.disabled != null ? props.disabled : false}
						onBlur={props.onBlur != null ? props.onBlur : null}
					/>
				)}
			/>
		</div>
	);

	const renderTextarea = () => (
		<div className="input-field">
			<FormField
				name={props.name}
				render={({ input, meta }) => (
					<Editor
						{...input}
						placeholder={props.placeholder}
						disabled={props.disabled != null ? props.disabled : false}
						onBlur={props.onBlur != null ? props.onBlur : null}
					/>
				)}
			/>
		</div>
	);

	const renderDecision = () => (
		<div className="input-field decision-radio-group">
			<FormField
				name={props.name}
				render={({ input, meta }) => {
					let labels = ['Approved', 'Denied'];
					try {
						const parsed = JSON.parse(props.placeholder || '[]');
						if (Array.isArray(parsed)) labels = parsed;
					} catch (e) { }
					return (
						<DecisionRadioGroup
							input={input}
							meta={meta}
							name={input ? input.name : props.name}
							onChange={input ? input.onChange : undefined}
							disabled={props.disabled != null ? props.disabled : false}
							labels={labels}
							translate={props.translate}
						/>
					)
				}} />
		</div>
	);

	const renderStartEnd = () => (
		<div className="input-field start-end-inputs">
			<FormField
				name={props.name}
				render={({ input, meta }) => {
					let parsed = { start: '', end: '', labels: { startLabel: props.translate ? props.translate('start') || 'Start' : 'Start', endLabel: props.translate ? props.translate('end') || 'End' : 'End' } };
					try {
						const p = JSON.parse(props.placeholder || '{}');
						if (p) parsed = { ...parsed, ...p };
					} catch (e) { }

					let current = { start: '', end: '' };
					try {
						current = input && input.value && typeof input.value === 'string' ? JSON.parse(input.value) : input.value || { start: '', end: '' };
					} catch (e) { current = { start: '', end: '' } }

					const handleChange = (next) => {
						const payload = JSON.stringify({ start: next.start || '', end: next.end || '' });
						if (input && input.onChange) input.onChange(payload);
					};

					return (
						<StartEndInputs input={{ name: input && input.name, value: { start: current.start || parsed.start, end: current.end || parsed.end }, onChange: handleChange }} disabled={props.disabled != null ? props.disabled : false} labels={parsed.labels} />
					)
				}} />
		</div>
	);

	return (
		<div className="form-row field">
			{type === FIELD_TITLE && renderTitle()}
			{type === FIELD_DESCRIPTION && renderDescription()}
			{type === FIELD_TEXT && renderText()}
			{type === FIELD_TEXTAREA && renderTextarea()}
			{type === FIELDS_INPUT_DECISION_RADIOGROUP && renderDecision()}
			{type === FIELDS_START_END_INPUTS && renderStartEnd()}
		</div>
	);
}

export default Field;
